import { Box, Icon, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { DialogBox } from '../../common/components/DialogBox';
import { ReactComponent as ChromeIcon } from '../images/chrome.svg';
import { ReactComponent as FirefoxIcon } from '../images/firefox.svg';
import { ReactComponent as EdgeIcon } from '../images/edge.svg';
import { ReactComponent as SafariIcon } from '../images/safari.svg';
import { isBrowserSupported } from '../../common/utils/browserDetect';
import { matchPath, useLocation } from 'react-router-dom';
import { routeMappings } from '../../constants';
import { BrowserSuggestionStyles } from '../styles/browserSuggestion';
import { useTranslation } from 'react-i18next';

export const BrowserSuggestion = (): JSX.Element => {
  const { t } = useTranslation();
  const location = useLocation();
  const classes = BrowserSuggestionStyles();
  const [gotIt, setGotIt] = useState(false);

  useEffect(() => {
    setGotIt(false);
  }, [location.pathname]);

  const basicTaskListUrl = matchPath(location.pathname, {
    path: `${routeMappings['BASICTASKLIST']}/:id`,
    exact: true,
  });

  const taskListUrl = matchPath(location.pathname, {
    path: `${routeMappings['TASKLIST']}/:id`,
    exact: true,
  });

  const taskUrl = matchPath(location.pathname, {
    path: `${routeMappings['TASK']}/:id${routeMappings['GENCONTENT']}/:itemId`,
    exact: true,
  });

  const onTaskRelatedPages = basicTaskListUrl || taskListUrl || taskUrl;
  const hide = !onTaskRelatedPages || (onTaskRelatedPages && isBrowserSupported()) || gotIt;

  if (hide) return <></>;

  return (
    <DialogBox buttonText={t('gotIt')} onSubmit={(): void => setGotIt(true)}>
      <Box textAlign="center">
        <Typography color="inherit" variant="h1" align="center" className={classes.title}>
          {t('browserSupportTitle')}
        </Typography>
        <Typography color="inherit" variant="h3" align="center" className={classes.content}>
          <Box className={classes.browser}>
            <Icon className={`${classes.browserIcon} ${classes.firstBrowserIcon}`}>
              <ChromeIcon />
            </Icon>
            Google Chrome
          </Box>
          <Box className={classes.browser}>
            <Icon className={classes.browserIcon}>
              <FirefoxIcon />
            </Icon>
            Firefox
          </Box>
          <Box className={classes.browser}>
            <Icon className={classes.browserIcon}>
              <EdgeIcon />
            </Icon>
            Microsoft Edge
          </Box>
          <Box className={classes.browser}>
            <Icon className={classes.browserIcon}>
              <SafariIcon />
            </Icon>
            Safari
          </Box>
        </Typography>
      </Box>
    </DialogBox>
  );
};
